import { Stack, styled, StackProps } from '@mui/material';

const SectionContainer = styled(Stack)<StackProps>({
  margin: '0 auto',
  width: '100%',
  maxWidth: '27rem',
});

export default SectionContainer;
